<template>
  <div class="content-message">
    <div class="title">用户列表</div>
    <div class="search">
      <el-form class="search-from" ref="form" :model="searchForm" label-width="85px" size="small">
        <el-form-item label="用户昵称">
          <el-input style="width: 160px;" v-model="searchForm.nickName" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="公众号名称">
          <el-input style="width: 160px;" v-model="searchForm.officialName" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="注册时间">
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
          @change="getTime">
          </el-date-picker>
        </el-form-item>
          <div class="search-button">
            <div class="button-refer" @click="search">查询</div>
            <div class="button-export" @click="exportButton">导出</div>
          </div>
      </el-form>
    </div>
    <div class="table">
      <div class="table-list">
        <el-table
          :data="list.list"
          style="width: 100%"
          :header-cell-style="bgColor"
        v-loading="loading">
          <el-table-column
            label="序号"
            width="80"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="用户"
            width="180"
            align="center">
            <template slot-scope="{row}">
              <div class="head" @click="detail(row)">
                <img class="head-img" :src="row.headPic" alt="">
                <span>{{ row.nickName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="公众号"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.appName }}</span>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="用户身份"-->
<!--            align="center">-->
<!--            <template slot-scope="{row}">-->
<!--              <span>{{ row.id }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            label="推荐人"-->
<!--            align="center">-->
<!--            <template slot-scope="{row}">-->
<!--              <span>{{ row.id }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            label="账户余额"-->
<!--            align="center">-->
<!--            <template slot-scope="{row}">-->
<!--              <span>{{ row.id }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            label="下单数量"
            align="center">
            <template slot-scope="{row}">
              <span @click="goOrder(row)" style="cursor: pointer">{{ row.orderNum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="注册时间"
            align="center"
            width="180">
            <template slot-scope="{row}">
              <span>{{ row.registerTime }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="list.total > 0"
          background
          class="align-right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="list.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.total">
        </el-pagination>
      </div>
    </div>
<!--    用户信息弹窗-->
    <el-dialog
      title="用户信息"
      :visible.sync="userMessage"
      width="30%"
      :before-close="handleClose">
      <div class="center">
        <div class="center-item">
          <div class="title">用户UUID：</div>
          <div class="text">{{ detailMessage.id }}</div>
        </div>
        <div class="center-item">
          <div class="title">注册时间：</div>
          <div class="text">{{ detailMessage.registerTime }}</div>
        </div>
<!--        <div class="center-item">-->
<!--          <div class="title">推荐人ID：</div>-->
<!--          <div class="text">123</div>-->
<!--        </div>-->
<!--        <div class="center-item">-->
<!--          <div class="title">支付宝账号：</div>-->
<!--          <div class="text">12321312312</div>-->
<!--        </div>-->
<!--        <div class="center-item">-->
<!--          <div class="title">可用金额：</div>-->
<!--          <div class="text">￥12312</div>-->
<!--        </div>-->
<!--        <div class="center-item">-->
<!--          <div class="title">是否总监：</div>-->
<!--          <div class="text">是</div>-->
<!--        </div>-->
      </div>
      <div class="button">
        <div class="button-confirm" @click="userMessage = false">关闭</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saasOrder } from "../../../../javaApi/saasOrder";
const SaasM = new saasOrder()
export default {
name: "index",
  data(){
    return{
      searchForm:{
        officialName:'',
        pageNo:1,
        pageSize:10,
        startTime:'',
        endTime:'',
      },
      list:[],
      time:'',
      // 表头颜色
      bgColor:{
        background: '#FCFAF8'
      },
      userMessage:false,
      currentPage:1,
      detailMessage:{},
      loading:true
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    handleClose(){
      this.userMessage = false
    },
    pageChange(){

    },
    getList(){
      let params = this.searchForm
      SaasM.getUserOrder(params).then(res=>{
        if(res.data.code == 200){
          this.list = res.data.data
          this.loading = false
        }else {
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    // 搜索
    search(){
      this.loading = true
      this.getList()
    },
    getTime(e){
      console.log(e)
      if(this.time != null){
        this.searchForm.startTime = e[0]
        this.searchForm.endTime = e[1]
      }else{
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    // 导出
    exportButton(){
      SaasM.exportUserList(this.searchForm).then(res=>{
        console.log(res)
        if(res.status == 200){
          const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
          console.log('blob',blob)
          let url = window.URL.createObjectURL(blob);
          console.log('url',url)
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = window.URL.createObjectURL(blob);;
          a.download = "订单导出_" + this.formatDate(new Date()) + ".xls";
          a.click();
          window.URL.revokeObjectURL(url);
        }else{
          // this.$Message.error(res.info || res.message)
        }
      })
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + m + d;
    },
    detail(row){
      console.log(row)
      this.userMessage = true
      this.detailMessage = row
    },
    // 跳转
    goOrder(row){
      this.$router.push({
        path:'/pc/SaasJoin/movieOrderList/index',
        query:{
          nickName:row.nickName
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.content-message{
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  min-height: 92%;
  .title{
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 25px;
  }
  .search{
    margin-top: 20px;
    display: flex;
    align-items: center;
    .search-from{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .search-button{
      display: flex;
      align-items: center;
      margin-left: 20px;
      .button-refer{
        width: 76px;
        height: 32px;
        background: #FF8622;
        border-radius: 2px;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 32px;
        cursor: pointer;
      }
      .button-export{
        width: 76px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #FF8622;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FF8622;
        line-height: 32px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
.button{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 43px;
  .button-cancel{
    width: 76px;
    height: 32px;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 32px;
    margin:0 10px;
    cursor: pointer;
  }
  .button-confirm{
    width: 104px;
    height: 32px;
    background: #FF8622;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #ffffff;
    line-height: 32px;
    margin: 0 10px;
    cursor: pointer;
  }
}
.center{
  .center-item{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .title{
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 20px;
      width: 90px;
      text-align: right;
    }
    .text{
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 20px;
    }
  }
}
.head{
  width: 200px;
  text-align: left;
}
.head-img{
  width: 28px;
  height: 28px;
  border-radius: 100%;
  margin-right: 8px;
}
.table{
  margin-top: 20px;
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #e5e5e5;
}
/deep/.el-input__inner:focus{
  border-color: #FF8622!important;
}
/deep/.el-range-editor.is-active, .el-range-editor.is-active:hover{
  border-color: #FF8622!important;
}
/deep/.el-date-table td.today{
  background: #FF8622;
}
/deep/.el-input__inner:hover{
  background: #FCF8F5;
  border-color: #FF8622!important;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #FF8622!important;
}
.align-right{
  text-align: right;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/userList/index.vue